module.exports = __webpack_public_path__ + "img/lu.b64e7689.svg";